import { Field, Entity } from "typegraph";
@Entity({one: "permission"})
export default class Permission {

    @Field()
    public id: number;

    @Field()
    public entityId: number;

    @Field()
    public entityType: number;

    @Field()
    public action: string;

    @Field()
    public roleId: string;

    @Field ()
    public groupId: number


}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/ForumPermissions.ts